import { render } from "./ButtonStatusLeave.vue?vue&type=template&id=4960c45e&scoped=true"
import script from "./ButtonStatusLeave.vue?vue&type=script&lang=js"
export * from "./ButtonStatusLeave.vue?vue&type=script&lang=js"

import "./ButtonStatusLeave.vue?vue&type=style&index=0&id=4960c45e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4960c45e"]])

export default __exports__